import { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { Button, TextField  } from '@mui/material';
import "../styles/sms-verification-modal.scss";
import { sendSMSCode, verifySMSCode } from './api';
import { setNotificationMessage, setShowNotification } from '../store';


export const SMSVerificationModal = ({ isOpen, phone, onClose, onConfirm }) => {
    const [code, setCode] = useState('');
    const [timer, setTimer] = useState(60);

    useEffect(() => {
        if (!isOpen) 
            return;
        const interval = setInterval(() => {
            setTimer((prev) => (prev > 0 ? prev - 1 : 0));
        }, 1000);
        return () => clearInterval(interval);
    }, [isOpen, timer]);

    useEffect(() => {
        if (!isOpen) 
            return;
        sendSMSCode({ phone: phone })
            .then()
            .catch(error => {
                const errorMessageData = error?.response?.data?.message;
                setNotificationMessage(errorMessageData
                    ? errorMessageData
                    : "Произошла непредвиденная ошибка");
                setShowNotification(true);
            });
    }, [isOpen]);

    if (!isOpen) return null;

    const checkSMSCode = () => {
        verifySMSCode({phone: phone, code: code})
            .then(onConfirm)
            .catch(error => {
                const errorMessageData = error?.response?.data?.message;
                setNotificationMessage(errorMessageData
                    ? errorMessageData
                    : "Произошла непредвиденная ошибка");
                setShowNotification(true);
            });
    }

    const resendSMSCode = () => {
        sendSMSCode({ phone: phone })
            .then(data => {
                setTimer(data?.hasExceededDailyLimit ? 600 : 60);
            })
            .catch(error => {
                const errorMessageData = error?.response?.data?.message;
                setNotificationMessage(errorMessageData
                    ? errorMessageData
                    : "Произошла непредвиденная ошибка");
                setShowNotification(true);
            });
    }
    const formatPhone = (stringPhone) => {
        return stringPhone.replace(/(\+7)(\d{3})(\d{3})(\d{2})(\d{2})/, '$1 ($2) $3-$4-$5');
    }

return (
    <Modal
        className="modal-content-custom"
        overlayClassName="modal-overlay-custom"
        isOpen={isOpen}>
        <div className='close-btn'>
            <Button variant="contained" onClick={onClose}>&times;</Button>
        </div>
        <h2 className='header'>Подтверждение номера</h2>
        <p className='header'>{formatPhone(phone)}</p>
        
        <p> На указанный номер придёт SMS-сообщение с кодом для подтверждения. </p>

        <div className='input-group'>
            <TextField 
                type="text" 
                placeholder="Код" 
                value={code ?? ""}
                onChange={e => setCode(e.target.value)}
                className='input'
                required
                fullWidth
                margin="normal"
                slotProps={{
                    htmlInput: {
                        maxLength: 4,
                        inputMode: 'numeric',
                    }
                }}
            />
            <Button variant="contained" className='confirm-btn' disabled={code.length !== 4 } onClick={() => checkSMSCode()} >Подтвердить</Button>
        </div>

        <p className='timer-text'>
        {timer > 0 
            ? `Попробовать еще раз через ${timer} сек.` 
            : <span className='timer' onClick={() => resendSMSCode()}>Отправить повторно</span>
        }
        </p>
    </Modal>
    )
}